export const STATE = 'message'

export const SET_CHAT_REQUEST = `${STATE}/CHAT_REQUEST`

export const SET_CHAT_REQUEST_USERS = `${STATE}/CHAT_REQUEST_USERS`
export const SET_CHAT_MEETING_USERS = `${STATE}/CHAT_MEETING_USERS`
export const SET_CHAT_SCHEDULE_USERS = `${STATE}/CHAT_SCHEDULE_USERS`
export const SET_CHAT_DATE_UTC = `${STATE}/CHAT_DATE_UTC`
export const SET_STORY_DISCUS = `${STATE}/STORY_DISCUS`
export const SET_MESSAGE_USERS = `${STATE}/MESSAGE_USERS`
export const SET_OPEN_CHAT = `${STATE}/OPEN_CHAT`
export const SET_NO_READR_MESSAGES = `${STATE}/NO_READ_MESSAGES`
export const SET_MEET_REVIEW = `${STATE}/MEET_REVIEW`
